/* import __COLOCATED_TEMPLATE__ from './dropdown-transaction-volume.hbs'; */
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { YEARLY_TRANSACTION_VOLUME_OPTIONS } from 'register-partners-js/constants/business-finances';

export default class DropdownTransactionVolume extends Component {
  @service intl;

  get selectedValue() {
    let code = this.args.organization.yearlyTransactionVolume;

    if (code) {
      let name = this.yearlyTransactionVolumeOptionsTranslations[code];
      return { code, name };
    }
    return null;
  }

  get yearlyTransactionVolumeOptionsTranslations() {
    return {
      [YEARLY_TRANSACTION_VOLUME_OPTIONS[0]]: this.intl.t(
        'partner-register-kyb.business-finances.yearly-transaction-volume.option1'
      ),
      [YEARLY_TRANSACTION_VOLUME_OPTIONS[1]]: this.intl.t(
        'partner-register-kyb.business-finances.yearly-transaction-volume.option2'
      ),
      [YEARLY_TRANSACTION_VOLUME_OPTIONS[2]]: this.intl.t(
        'partner-register-kyb.business-finances.yearly-transaction-volume.option3'
      ),
      [YEARLY_TRANSACTION_VOLUME_OPTIONS[3]]: this.intl.t(
        'partner-register-kyb.business-finances.yearly-transaction-volume.option4'
      ),
      [YEARLY_TRANSACTION_VOLUME_OPTIONS[4]]: this.intl.t(
        'partner-register-kyb.business-finances.yearly-transaction-volume.option5'
      ),
    };
  }

  get options() {
    return YEARLY_TRANSACTION_VOLUME_OPTIONS.map(code => ({
      code,
      name: this.yearlyTransactionVolumeOptionsTranslations[code],
    }));
  }

  @action
  handleUpdate(transactionVolumeObject) {
    this.args.organization.yearlyTransactionVolume = transactionVolumeObject.code;
  }
}
